import { render } from "./Sidebar.vue?vue&type=template&id=f20941d2"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
script.render = render

export default script